export const enum AuthTypes {
  azure,
  oauth2
}

export type AuthConfig = {
  type: AuthTypes;
  clientId?: string;
  clientSecret?: string;
};